import React, { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Divider, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CommentDrawer from '../../components/Common/Drawer';
import FileUploader from '../../components/Common/FileUploader';
import { createLandPage, updateLandPage } from '../../store/LandPageSlice';

export default function LandingPageForm({ title, landingPageModal, setLandingPageModal, resetTrigger, selectedLandingPage = null }) {
    const dispatch = useDispatch();
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();
    const [filePreview, setFilePreview] = useState(null);
    const [fileType, setFileType] = useState(null);
    const validationSchema = Yup.object({
        keyword: Yup.string()
            .matches(/^[A-Za-z\s]+$/, "Keyword must contain only letters (A-Z or a-z) without numbers or special characters.")
            .required("Keyword is required"),
        title: Yup.string().required("Title is required"),
        body: Yup.string().required("Description is required"),
        media: Yup.mixed()
            .required('File is required')
    });
    const formik = useFormik({
        initialValues: {
            keyword: "",
            title: "",
            body: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("submit form", values);
            const formData = new FormData();

            formData.append('keyword', values.keyword);
            formData.append('title', values.title);
            formData.append('body', values.body);
            setLandingPageModal(false);
            if (selectedLandingPage) {
                console.log("selectedLandingPage", selectedLandingPage);
                if (fileType === "video") {
                    formData.append('videos', values.media);
                }
                if (fileType === "image") {
                    formData.append('images', values.media);
                }
                values.id = selectedLandingPage.uuid;
                values.formData = formData;
                dispatch(updateLandPage(values))
            } else {
                if (fileType === "video") {
                    formData.append('videos', values.media);
                } else {
                    formData.append('images', values.media);
                }
                dispatch(createLandPage(formData))
            }
        },
    });

    useEffect(() => {
        if (selectedLandingPage?.title && landingPageModal) {
            formik.setValues({
                keyword: selectedLandingPage.keyword,
                title: selectedLandingPage.title,
                body: selectedLandingPage.body,
                media: selectedLandingPage.photos[0]?.video || selectedLandingPage?.photos[0]?.image ||selectedLandingPage?.photos[0]?.external_url,
            });
            setFilePreview(selectedLandingPage?.photos[0]?.video || selectedLandingPage?.photos[0]?.image || selectedLandingPage?.photos[0]?.external_url)
        } else {
            formik.resetForm();
        }
    }, [selectedLandingPage, landingPageModal, resetTrigger]);


    useEffect(() => {

        if (selectedLandingPage) {
            const industries = selectedLandingPage?.industries?.map((ele) => ele.industry.id);
            const disabled = JSON.stringify({
                keyword: formik.values.keyword,
                title: formik.values.title,
                body: formik.values.body,
                media: formik.values.media,
            }) === JSON.stringify({
                keyword: selectedLandingPage.keyword,
                title: selectedLandingPage.title,
                body: selectedLandingPage.body,
                media: selectedLandingPage.media,
            });

            setIsButtonDisabled(disabled)
        }

    }, [selectedLandingPage, formik.values])
    return (
        <CommentDrawer open={landingPageModal} setOpen={setLandingPageModal}>
            <Box className="p-3 position-relative h-100">
                <form onSubmit={formik.handleSubmit} >
                    <Typography variant="h6" gutterBottom>
                        {title}
                    </Typography>
                    <Divider />
                    <div className="role-form-scroller" >
                        <TextField
                            fullWidth
                            required
                            id="title"
                            name="title"
                            label="Title"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.title && Boolean(formik.errors.title)}
                            helperText={formik.touched.title && formik.errors.title}
                        />
                        <TextField
                            fullWidth
                            required
                            id="keyword"
                            name="keyword"
                            label="Keyword"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.keyword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.keyword && Boolean(formik.errors.keyword)}
                            helperText={formik.touched.keyword && formik.errors.keyword}
                        />
                        <TextField
                            fullWidth
                            required
                            id="body"
                            name="body"
                            label="Description"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.body}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.body && Boolean(formik.errors.body)}
                            helperText={formik.touched.body && formik.errors.body}
                        />
                        <FileUploader formik={formik} {...{ fileType, setFileType, filePreview, setFilePreview }} name="media" />
                    </div>
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => setLandingPageModal(false)}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={selectedLandingPage ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}